import { render, staticRenderFns } from "./PersiapanLelang.vue?vue&type=template&id=689c90a9&"
import script from "./PersiapanLelang.vue?vue&type=script&lang=js&"
export * from "./PersiapanLelang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports